import { setTheme } from "theme/default/setTheme";

export const color_rgba_0_0_0_87 = setTheme(({ theme }) => theme.colors.color_rgba_0_0_0_87);
